/* ==========================================================================
   3WOOD | PAGE SECTIONS  (assets/tw-pages.js)
   Product selector (tabs) + cut-pack accordion. Safe to load more than once.
   Works with the theme editor (re-initialises on shopify:section:load).
   ========================================================================== */
(function () {
  if (window.__twPages) return;
  window.__twPages = true;

  function initTabs(root) {
    var tablist = root.querySelector('[role="tablist"]');
    if (!tablist || tablist.dataset.twReady) return;
    tablist.dataset.twReady = '1';
    var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
    var panels = tabs.map(function (t) { return document.getElementById(t.getAttribute('aria-controls')); });

    function select(index, focus) {
      tabs.forEach(function (t, i) {
        var on = i === index;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        if (panels[i]) panels[i].hidden = !on;
      });
      if (focus) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { select(i, false); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i + tabs.length - 1) % tabs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });

    var start = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
    select(start < 0 ? 0 : start, false);
  }

  function initAccordion(root) {
    if (root.dataset.twReady) return;
    root.dataset.twReady = '1';
    var triggers = Array.prototype.slice.call(root.querySelectorAll('.tw-step__btn'));
    var panels = triggers.map(function (b) { return document.getElementById(b.getAttribute('aria-controls')); });

    function open(index) {
      triggers.forEach(function (b, i) {
        b.setAttribute('aria-expanded', String(i === index));
        if (panels[i]) panels[i].hidden = i !== index;
      });
    }

    triggers.forEach(function (b, i) {
      b.addEventListener('click', function () {
        open(b.getAttribute('aria-expanded') === 'true' ? -1 : i);
      });
      b.addEventListener('keydown', function (e) {
        var n;
        if (e.key === 'ArrowDown') n = (i + 1) % triggers.length;
        if (e.key === 'ArrowUp') n = (i + triggers.length - 1) % triggers.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = triggers.length - 1;
        if (n !== undefined) { e.preventDefault(); triggers[n].focus(); }
      });
    });

    var first = triggers.findIndex(function (b) { return b.getAttribute('aria-expanded') === 'true'; });
    open(first < 0 ? 0 : first);
  }

  function init(scope) {
    var ctx = scope || document;
    ctx.querySelectorAll('[data-tw-tabs]').forEach(initTabs);
    ctx.querySelectorAll('[data-tw-accordion]').forEach(initAccordion);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();